import LevelApi from "../../services/api/GenSetting";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in level actions:", err);
}

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_LEVEL,
    payload,
  };
};

export const setLevelList = (payload) => {
  return {
    type: ActionTypes.SET_LEVEL,
    payload,
  };
};

export const setOrder = (payload) => {
  return {
    type: ActionTypes.SET_ORDER,
    payload,
  };
};

export const getLevel =
  (order = {}, MergedRuleList) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        order: order,
        merged_config: {
          rules: MergedRuleList,
        },
      };
      dispatch(setLoader(true));
      let response = await LevelApi.getLevel(finalPayload);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setLevelList(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
